import React from 'react';
import { Box, Typography } from '@mui/material';

const Billing: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
      <Typography variant="h5">Billing Page Placeholder</Typography>
    </Box>
  );
};

export default Billing;
